import { taskDetailUrl } from './taskDetailPath'

export function buildSourceLink(update: {
  source_type: string
  source_id: string | null
  project_id: string | null
  source_meta?: Record<string, unknown> | null
}): string | null {
  if (!update.source_id) return null
  if (update.source_type === 'guidance_update') {
    return `/guidance/updates/${update.source_id}`
  }
  if (!update.project_id) return null
  const pid = update.project_id

  switch (update.source_type) {
    case 'bug':
      return `/projects/${pid}/bugs/${update.source_id}`
    case 'exploration':
      return taskDetailUrl(pid, update.source_id)
    case 'test_run':
      return taskDetailUrl(pid, update.source_id)
    case 'task':
      return taskDetailUrl(pid, update.source_id)
    default:
      return null
  }
}
